import { useCallback } from 'preact/hooks';
import { api, qs } from '../lib/api.js';
import { useFetch } from '../lib/useFetch.js';
import type { FeedbackListResponse, TelemetrySummary } from '../lib/types.js';
import { StatTile } from '../components/StatTile.js';
import { Sparkline } from '../components/Chart.js';
import { formatPct } from '../lib/format.js';

export function Overview() {
  const fetchSummary = useCallback(
    () => api.get<TelemetrySummary>('/api/admin/telemetry/summary'),
    [],
  );
  const fetchNewFeedback = useCallback(
    () => api.get<FeedbackListResponse>(`/api/admin/feedback${qs({ status: 'new', page: 1 })}`),
    [],
  );
  const summary = useFetch(fetchSummary, []);
  const feedback = useFetch(fetchNewFeedback, []);

  const dau = summary.data?.dau ?? [];
  const today = summary.data?.raids[summary.data.raids.length - 1];
  const latestDau = dau[dau.length - 1];

  return (
    <div>
      <h1 class="page-title">Overview</h1>
      {summary.error && <div class="error-banner">{summary.error}</div>}

      <div class="tiles">
        <StatTile label="Players online" value={summary.data?.playersOnline ?? '—'} />
        <StatTile label="Sessions today" value={summary.data?.sessionsToday ?? '—'} />
        <StatTile label="Raids today" value={today?.count ?? '—'} />
        <StatTile label="Extract rate" value={today ? formatPct(today.extractRate) : '—'} />
        <StatTile label="New feedback" value={feedback.data?.total ?? '—'} sub="awaiting triage" />
        <StatTile
          label="D1 / D7 retention"
          value={
            summary.data
              ? `${formatPct(summary.data.retention.d1)} / ${formatPct(summary.data.retention.d7)}`
              : '—'
          }
        />
        <StatTile label="DAU" value={latestDau?.count ?? '—'} sub="last 14 days">
          {dau.length > 1 && (
            <div style={{ marginTop: '6px' }}>
              <Sparkline values={dau.map((d) => d.count)} />
            </div>
          )}
        </StatTile>
      </div>
    </div>
  );
}
